import { createReducer } from '@reduxjs/toolkit';

import { resetListingsFilter, setListingsFilter } from '../../actions/listings/listingsFilter';

const initialState = {
  page: 1,
  size: 15,
  order: 'listing_id:desc',
  source: [
    'listing_seller_manufacturer',
    'listing_id',
    'listing_title',
    'listing_short_description',
    'ebay_status',
    'listing_image_source',
    'listing_image',
    'listing_market_account'
  ],
  filter: {
    listing_market_account: ['2dayparts.com'],
    ebay_status: ['Active'],
    // listing_ebay_category
    // listing_manufacturer
  }
};

const listingsFilterReducer = createReducer(initialState, {
  [setListingsFilter]: (state, { payload }) => ({
    ...state,
    ...payload,
    filter: {
      ...state?.filter,
      ...payload?.filter
    }
  }),
  [resetListingsFilter]: () => initialState
});

export default listingsFilterReducer;
